import type { CmsPageGroupMetadataModel } from '../../../models/cms/CmsPageGroupMetadataModel';
import QUERYKEYS from '../../../constants/queryKeys';
import config from '../../../config';
import { getLastModifiedPageGroups } from '../../../services/CmsPageGroupService';
import { useQuery } from 'react-query';

type TUseCmsLastModifiedPageGroups = {
  data?: Array<CmsPageGroupMetadataModel>;
  isError: boolean;
  isLoading: boolean;
};

export default function useCmsLastModifiedPages(): TUseCmsLastModifiedPageGroups {
  const { isLoading, isError, data } = useQuery(
    QUERYKEYS.LAST_MODIFIED_PAGE_GROUPS,
    async () => getLastModifiedPageGroups(),
    {
      staleTime: config.cmsIdleTimeoutInMinutes * 60 * 1000,
    },
  );

  return {
    data,
    isError,
    isLoading,
  };
}
